import { ChangeEvent, forwardRef, useState } from 'react';
import { FormControl, FormControlProps } from 'react-bootstrap';

type Props = FormControlProps & {
	fieldValue: string | number;
	updateRowData: (name: string, value: any) => void;
	name: string;
	disabled?: boolean;
};

const TableInputField = forwardRef<HTMLInputElement, Props>(
	({ fieldValue, name, updateRowData, disabled, ...props }: Props, ref) => {
		const [value, setValue] = useState(fieldValue);

		return (
			<FormControl
				ref={ref}
				name={name}
				value={value}
				onChange={(e: ChangeEvent<HTMLInputElement>) => {
					setValue(e.target.value);
				}}
				onBlur={() => {
					if (fieldValue !== value) {
						updateRowData(name, value);
					}
				}}
				className="customs-input text-center"
				disabled={disabled}
				type="number"
				{...props}
			/>
		);
	}
);

export default TableInputField;
